import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Strip the characters that break PostgREST's `.or()` grammar before a search
 * term is interpolated into a filter string. An unescaped `,` or `(` makes the
 * whole filter unparseable and errors the entire query, so every `.or()` built
 * from user input has to go through this.
 */
export function safeOrTerm(term: string): string {
  return term
    .replace(/[,()]/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}
